var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing"},[_c('Header'),_c('MainSection'),_c('Achievements'),_c('Benefits'),_c('GetStart'),_c('Organize'),_c('Appointment'),_c('Steps'),_c('Faq'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }